/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Storefrontofferstitle2Inputs */

const id_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran etalase`)
};

const ms_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran kedai`)
};

const da_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butikstilbud`)
};

const de_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront-Angebote`)
};

const en_us2_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront offers`)
};

const es_es2_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de catálogo`)
};

const es_mx2_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas en tienda`)
};

const fil_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga offer sa storefront`)
};

const fr_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres de la vitrine`)
};

const it_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte del negozio`)
};

const hu_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boltfront ajánlatok`)
};

const nl_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winkelaanbiedingen`)
};

const no_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butikktilbud`)
};

const pl_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty sklepowe`)
};

const pt_br2_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de catálogo`)
};

const pt_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas da loja`)
};

const ro_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte din magazin`)
};

const fi_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauppapaikan tarjoukset`)
};

const sv_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butikserbjudanden`)
};

const vi_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi cửa hàng`)
};

const tr_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza teklifleri`)
};

const cs_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky obchodu`)
};

const bg_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазинни оферти`)
};

const ru_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложения витрины`)
};

const uk_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропозиції магазину`)
};

const ar_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عروض المتجر`)
};

const hi_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टोरफ्रंट ऑफ़र`)
};

const th_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอหน้าร้าน`)
};

const ja_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントオファー`)
};

const zh_cn2_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店目录项`)
};

const zh_hant1_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店目錄項目`)
};

const ko_sandboxes_storefrontofferstitle2 = /** @type {(inputs: Sandboxes_Storefrontofferstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 오퍼`)
};

/**
* | output |
* | --- |
* | "Storefront offers" |
*
* @param {Sandboxes_Storefrontofferstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_storefrontofferstitle2 = /** @type {((inputs?: Sandboxes_Storefrontofferstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Storefrontofferstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "ms") return ms_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "da") return da_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "de") return de_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "fil") return fil_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "fr") return fr_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "it") return it_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "hu") return hu_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "nl") return nl_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "no") return no_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "pl") return pl_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "pt") return pt_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "ro") return ro_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "fi") return fi_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "sv") return sv_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "vi") return vi_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "tr") return tr_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "cs") return cs_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "bg") return bg_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "ru") return ru_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "uk") return uk_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "ar") return ar_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "hi") return hi_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "th") return th_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "ja") return ja_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_storefrontofferstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_storefrontofferstitle2(inputs)
	return ko_sandboxes_storefrontofferstitle2(inputs)
});
export { sandboxes_storefrontofferstitle2 as "sandboxes.storefrontOffersTitle" }